import * as React from 'react';

function SvgEc(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 640 480"
            width={props.width || 640}
            height={props.height || 480}
            {...props}
        >
            <g fillRule="evenodd" strokeWidth="1pt">
                <path fill="#ffe800" d="M0 0h640v480H0z" />
                <path fill="#00148e" d="M0 240h640v240H0z" />
                <path fill="#da0010" d="M0 360h640v120H0z" />
            </g>
            <g fillRule="evenodd">
                <path d="M269.55 290.834l-72.424 76.485-1.277-1.644 72.422-76.485 1.277 1.644zm50.452 12.5l-94.777 99.908-1.662-1.572 94.777-99.91 1.662 1.574z" />
                <path
                    d="M478.35 60.236v88.583l17.717 88.582 17.717-88.583V60.235H478.35z"
                    transform="matrix(-.07 -.07 -.1 .1 265.03 429.55)"
                    stroke="#000"
                    strokeWidth={4.104}
                    fill="gray"
                />
                <path
                    d="M478.35 60.236v88.583l17.717 88.582 17.717-88.583V60.235H478.35z"
                    transform="matrix(-.07 -.07 -.1 .1 240.59 390.52)"
                    stroke="#000"
                    strokeWidth={4.104}
                    fill="gray"
                />
            </g>
            <path
                d="M301.18 272.84s-17.716 336.61 53.15 336.61 106.3-35.433 106.3-35.433l-.86-185.03-158.59-116.15z"
                fillRule="evenodd"
                transform="matrix(.45 0 0 .64 72.37 -59.76)"
                stroke="#000"
                strokeWidth="1pt"
                fill="#ffdf00"
            />
            <path
                d="M344.46 304.2c0 17.717-7.846 269.82 27.587 269.82s88.583-17.717 88.583-17.717l-.86-167.31-115.31-84.79z"
                fillRule="evenodd"
                transform="matrix(.45 0 0 .64 72.37 -59.76)"
                stroke="#000"
                strokeWidth="1pt"
                fill="#0000c4"
            />
            <path
                d="M367.52 321.16c0 17.717 4.525 217.42 39.958 217.42h53.15l-.86-149.59-92.248-67.833z"
                fillRule="evenodd"
                transform="matrix(.45 0 0 .64 72.37 -59.76)"
                stroke="#000"
                strokeWidth="1pt"
                fill="#e10000"
            />
            <path d="M206.202 116.02l72.422 76.485 1.277-1.642-72.422-76.485-1.276 1.642z" fillRule="evenodd" />
            <path
                d="M301.18 272.84s-35.433 336.61 70.866 336.61c88.583 0 88.583-53.15 106.3-53.15l-17.72-124.02-159.45-159.44z"
                fillRule="evenodd"
                stroke="#000"
                strokeWidth="1pt"
                fill="#ffdf00"
                transform="matrix(.58 0 0 .62 9.63 -10.18)"
            />
            <g stroke="#000">
                <path
                    d="M269.59 155.24c1.133 0 28.318-94.016 118.94-147.25"
                    transform="matrix(.4 -.03 -.05 .35 135.14 147.37)"
                    strokeWidth={2.305}
                    fill="none"
                />
                <path
                    d="M421.37-20.327c0 18.133-4.567 31.716-11.328 45.31-5.627-18.125-9.06-27.177-9.06-45.31s6.83-35.114 12.458-48.707c2.23 12.46 7.93 30.574 7.93 48.707z"
                    fillRule="evenodd"
                    transform="matrix(.14 -.22 .3 .14 175.87 257.36)"
                    strokeWidth="1pt"
                    fill="#005b00"
                />
                <path
                    d="M454.22-169.28c0 4.066-3.804 7.363-8.495 7.363s-8.496-3.297-8.496-7.363 3.803-7.363 8.495-7.363 8.495 3.297 8.495 7.363z"
                    fillRule="evenodd"
                    transform="matrix(.18 -.1 .1 .17 177.61 256.68)"
                    strokeWidth="1pt"
                    fill="red"
                />
                <path
                    d="M421.37-20.327c0 18.133-4.567 31.716-11.328 45.31-5.627-18.125-9.06-27.177-9.06-45.31s6.83-35.114 12.458-48.707c2.23 12.46 7.93 30.574 7.93 48.707z"
                    fillRule="evenodd"
                    transform="matrix(.18 .12 -.13 .33 181 96.41)"
                    strokeWidth="1pt"
                    fill="#005b00"
                />
                <path
                    d="M421.37-20.327c0 18.133-4.567 31.716-11.328 45.31-5.627-18.125-9.06-27.177-9.06-45.31s6.83-35.114 12.458-48.707c2.23 12.46 7.93 30.574 7.93 48.707z"
                    fillRule="evenodd"
                    transform="matrix(.17 -.03 -.03 .33 179.31 159.26)"
                    strokeWidth="1pt"
                    fill="#005b00"
                />
                <path
                    d="M421.37-20.327c0 18.133-4.567 31.716-11.328 45.31-5.627-18.125-9.06-27.177-9.06-45.31s6.83-35.114 12.458-48.707c2.23 12.46 7.93 30.574 7.93 48.707z"
                    fillRule="evenodd"
                    transform="matrix(.06 .25 -.17 .2 227.98 45.45)"
                    strokeWidth="1pt"
                    fill="#005b00"
                />
                <path
                    d="M421.37-20.327c0 18.133-4.567 31.716-11.328 45.31-5.627-18.125-9.06-27.177-9.06-45.31s6.83-35.114 12.458-48.707c2.23 12.46 7.93 30.574 7.93 48.707z"
                    fillRule="evenodd"
                    transform="matrix(.2 -.2 .2 .24 150.27 241.08)"
                    strokeWidth="1pt"
                    fill="#005b00"
                />
                <path
                    d="M421.37-20.327c0 18.133-4.567 31.716-11.328 45.31-5.627-18.125-9.06-27.177-9.06-45.31s6.83-35.114 12.458-48.707c2.23 12.46 7.93 30.574 7.93 48.707z"
                    fillRule="evenodd"
                    transform="matrix(.22 -.22 .25 .2 135.57 282.11)"
                    strokeWidth="1pt"
                    fill="#005b00"
                />
                <path
                    d="M421.37-20.327c0 18.133-4.567 31.716-11.328 45.31-5.627-18.125-9.06-27.177-9.06-45.31s6.83-35.114 12.458-48.707c2.23 12.46 7.93 30.574 7.93 48.707z"
                    fillRule="evenodd"
                    transform="matrix(.26 .1 -.2 .32 130.78 147.66)"
                    strokeWidth="1pt"
                    fill="#005b00"
                />
                <path
                    d="M421.37-20.327c0 18.133-4.567 31.716-11.328 45.31-5.627-18.125-9.06-27.177-9.06-45.31s6.83-35.114 12.458-48.707c2.23 12.46 7.93 30.574 7.93 48.707z"
                    fillRule="evenodd"
                    transform="matrix(.15 .2 -.32 .22 178.5 103.35)"
                    strokeWidth="1pt"
                    fill="#005b00"
                />
                <path
                    d="M421.37-20.327c0 18.133-4.567 31.716-11.328 45.31-5.627-18.125-9.06-27.177-9.06-45.31s6.83-35.114 12.458-48.707c2.23 12.46 7.93 30.574 7.93 48.707z"
                    fillRule="evenodd"
                    transform="matrix(.08 .1 -.14 .16 250.68 102.64)"
                    strokeWidth="1pt"
                    fill="#005b00"
                />
                <path
                    d="M421.37-20.327c0 18.133-4.567 31.716-11.328 45.31-5.627-18.125-9.06-27.177-9.06-45.31s6.83-35.114 12.458-48.707c2.23 12.46 7.93 30.574 7.93 48.707z"
                    fillRule="evenodd"
                    transform="matrix(.1 0 -.08 .17 238.09 136.41)"
                    strokeWidth="1pt"
                    fill="#005b00"
                />
                <path
                    d="M421.37-20.327c0 18.133-4.567 31.716-11.328 45.31-5.627-18.125-9.06-27.177-9.06-45.31s6.83-35.114 12.458-48.707c2.23 12.46 7.93 30.574 7.93 48.707z"
                    fillRule="evenodd"
                    transform="matrix(0 .14 -.14 .08 287.38 81.13)"
                    strokeWidth="1pt"
                    fill="#005b00"
                />
                <path
                    d="M421.37-20.327c0 18.133-4.567 31.716-11.328 45.31-5.627-18.125-9.06-27.177-9.06-45.31s6.83-35.114 12.458-48.707c2.23 12.46 7.93 30.574 7.93 48.707z"
                    fillRule="evenodd"
                    transform="matrix(.07 .1 -.25 .15 220.69 115.6)"
                    strokeWidth="1pt"
                    fill="#005b00"
                />
                <path
                    d="M421.37-20.327c0 18.133-4.567 31.716-11.328 45.31-5.627-18.125-9.06-27.177-9.06-45.31s6.83-35.114 12.458-48.707c2.23 12.46 7.93 30.574 7.93 48.707z"
                    fillRule="evenodd"
                    transform="matrix(.13 .22 -.33 .2 207.03 70.11)"
                    strokeWidth="1pt"
                    fill="#005b00"
                />
                <path
                    d="M269.59 155.24c1.133 0 28.318-94.016 118.94-147.25"
                    transform="matrix(.35 -.2 .14 .28 111.76 227.82)"
                    strokeWidth={2.37}
                    fill="none"
                />
                <path
                    d="M454.22-169.28c0 4.066-3.804 7.363-8.495 7.363s-8.496-3.297-8.496-7.363 3.803-7.363 8.495-7.363 8.495 3.297 8.495 7.363z"
                    fillRule="evenodd"
                    transform="matrix(.18 -.1 .1 .17 200.34 224.62)"
                    strokeWidth="1pt"
                    fill="red"
                />
                <path
                    d="M454.22-169.28c0 4.066-3.804 7.363-8.495 7.363s-8.496-3.297-8.496-7.363 3.803-7.363 8.495-7.363 8.495 3.297 8.495 7.363z"
                    fillRule="evenodd"
                    transform="matrix(.18 -.1 .1 .17 211.12 218.26)"
                    strokeWidth="1pt"
                    fill="red"
                />
                <path
                    d="M454.22-169.28c0 4.066-3.804 7.363-8.495 7.363s-8.496-3.297-8.496-7.363 3.803-7.363 8.495-7.363 8.495 3.297 8.495 7.363z"
                    fillRule="evenodd"
                    transform="matrix(.2 -.1 .07 .13 166.81 232.7)"
                    strokeWidth="1pt"
                    fill="red"
                />
                <path
                    d="M454.22-169.28c0 4.066-3.804 7.363-8.495 7.363s-8.496-3.297-8.496-7.363 3.803-7.363 8.495-7.363 8.495 3.297 8.495 7.363z"
                    fillRule="evenodd"
                    transform="matrix(.2 -.1 .07 .13 169.93 231.34)"
                    strokeWidth="1pt"
                    fill="red"
                />
                <path
                    d="M454.22-169.28c0 4.066-3.804 7.363-8.495 7.363s-8.496-3.297-8.496-7.363 3.803-7.363 8.495-7.363 8.495 3.297 8.495 7.363z"
                    fillRule="evenodd"
                    transform="matrix(.2 -.1 .07 .13 168.14 234.25)"
                    strokeWidth="1pt"
                    fill="red"
                />
                <path
                    d="M252.646 167.252c.407.813-.024 1.853-.963 2.322s-2.029.19-2.435-.623.024-1.853.963-2.322 2.028-.19 2.435.623z"
                    fillRule="evenodd"
                    strokeWidth={0.298}
                    fill="red"
                />
                <path
                    d="M254.936 164.872c.407.813-.024 1.853-.963 2.322s-2.029.19-2.435-.623.024-1.853.963-2.322 2.028-.19 2.435.623z"
                    fillRule="evenodd"
                    strokeWidth={0.298}
                    fill="red"
                />
                <path
                    d="M255.516 166.022c.407.813-.024 1.853-.963 2.322s-2.029.19-2.435-.623.024-1.853.963-2.322 2.028-.19 2.435.623z"
                    fillRule="evenodd"
                    strokeWidth={0.298}
                    fill="red"
                />
            </g>
            <path
                d="M336.61 308.27c0 17.717-35.433 212.6 53.15 265.75 35.433 17.716 88.582-17.717 88.582 0l-17.71-141.74-124.02-124.01z"
                fillRule="evenodd"
                transform="matrix(.58 0 0 .62 9.63 -10.18)"
                stroke="#000"
                strokeWidth="1pt"
                fill="#0000c4"
            />
            <path
                d="M372.05 343.7c0 17.717-17.716 159.45 35.433 194.88 35.433 35.433 124.02 25.822 124.02 25.822l-70.87-132.12-88.58-88.58z"
                fillRule="evenodd"
                stroke="#000"
                strokeWidth="1pt"
                fill="#e10000"
                transform="matrix(.58 0 0 .62 9.63 -10.18)"
            />
            <path d="M183.85 158.08l94.775 99.91 1.662-1.573-94.776-99.91-1.66 1.574z" fillRule="evenodd" />
            <path
                d="M460.63 184.25l17.716 35.433V237.4c-.865-1.305 0 17.716-17.716 17.716-17.717 0-17.717-35.433-17.717-35.433s-17.716 35.433-17.716 70.866 17.716 53.15 17.716 53.15-2.61-36.704 17.717-35.434c20.328 1.27 17.716 17.716 17.716 17.716v35.433h17.717v-141.73l17.717-35.433-27.136-53.15-26.014 53.15z"
                fillRule="evenodd"
                transform="matrix(.14 -.14 .1 .1 86.35 192.15)"
                stroke="#000"
                strokeWidth="1pt"
                fill="#cececc"
            />
            <path
                d="M557.82 95.67l-26.323 70.865 17.717 53.15-35.433-17.716 35.434 53.148v35.433h17.716v-35.43l35.433-53.15-35.433 17.717 17.717-53.15L557.82 95.67z"
                fillRule="evenodd"
                transform="matrix(.1 -.16 .14 .1 113.99 183.83)"
                stroke="#000"
                strokeWidth="1pt"
                fill="#cececc"
            />
            <path
                d="M422.53 136.96c0 2.068-1.958 3.746-4.37 3.746-2.413 0-4.372-1.678-4.372-3.746s1.96-3.747 4.37-3.747c2.414 0 4.372 1.68 4.372 3.747zm-6.244 7.91c0 35.8 20.917 187.81 22.582 191.56.14 4.44-4.718 6.382-7.077.832-6.55-17.342-20.743-159.91-21.332-193.22-.244-13.734 3.76-14.8 8.326-14.57 3.76.21 8.325 3.725 8.325 7.91 0 4.995-5.83 8.74-10.824 7.492z"
                fillRule="evenodd"
                transform="matrix(.4 0 0 .3 43.75 69.8)"
                stroke="#000"
                strokeWidth="1pt"
                fill="#e10000"
            />
            <path
                d="M422.53 136.96c0 2.068-1.958 3.746-4.37 3.746-2.413 0-4.372-1.678-4.372-3.746s1.96-3.747 4.37-3.747c2.414 0 4.372 1.68 4.372 3.747zm-6.244 7.91c31.488 61.414 48.722 166.77 50.387 170.52.14 4.44-4.718 6.382-7.077.832-2.48-3.315-12.667-100.18-49.138-172.18-.244-13.734 3.76-14.8 8.326-14.57 3.76.21 8.325 3.725 8.325 7.91 0 4.995-5.83 8.74-10.824 7.492z"
                fillRule="evenodd"
                transform="matrix(.38 .1 -.15 .3 76.05 38.16)"
                stroke="#000"
                strokeWidth="1pt"
                fill="#0000c4"
            />
            <path
                d="M186.655 151.54c0 1.034-.979 1.873-2.185 1.873-1.207 0-2.186-.839-2.186-1.873s.98-1.873 2.185-1.873c1.207 0 2.186.84 2.186 1.873zm-3.122 3.955c0 17.9 10.458 93.905 11.291 95.78.07 2.22-2.359 3.191-3.539.416-3.275-8.671-10.371-79.955-10.666-96.61-.122-6.867 1.88-7.4 4.163-7.285 1.88.105 4.163 1.863 4.163 3.955 0 2.498-2.915 4.37-5.412 3.746z"
                fillRule="evenodd"
                stroke="#000"
                strokeWidth=".5pt"
                fill="#e10000"
            />
            <path
                d="M422.53 136.96c0 2.068-1.958 3.746-4.37 3.746-2.413 0-4.372-1.678-4.372-3.746s1.96-3.747 4.37-3.747c2.414 0 4.372 1.68 4.372 3.747zm-6.244 7.91c31.488 61.414 48.722 166.77 50.387 170.52.14 4.44-4.718 6.382-7.077.832-2.48-3.315-12.667-100.18-49.138-172.18-.244-13.734 3.76-14.8 8.326-14.57 3.76.21 8.325 3.725 8.325 7.91 0 4.995-5.83 8.74-10.824 7.492z"
                fillRule="evenodd"
                transform="matrix(.48 .15 -.2 .48 16.67 31.58)"
                stroke="#000"
                strokeWidth="1pt"
                fill="#0000c4"
            />
            <g fillRule="evenodd">
                <path d="M370.454 290.834l72.423 76.485 1.277-1.644-72.423-76.485-1.276 1.644zM320 303.334l94.778 99.908 1.662-1.572-94.777-99.91-1.662 1.574z" />
                <path
                    d="M478.35 60.236v88.583l17.717 88.582 17.717-88.583V60.235H478.35z"
                    transform="matrix(.07 -.07 .1 .1 374.97 429.55)"
                    stroke="#000"
                    strokeWidth={4.104}
                    fill="gray"
                />
                <path
                    d="M478.35 60.236v88.583l17.717 88.582 17.717-88.583V60.235H478.35z"
                    transform="matrix(.07 -.07 .1 .1 399.41 390.52)"
                    stroke="#000"
                    strokeWidth={4.104}
                    fill="gray"
                />
            </g>
            <g fillRule="evenodd" strokeWidth="1pt">
                <path
                    d="M301.18 272.84s-17.716 336.61 53.15 336.61 106.3-35.433 106.3-35.433l-.86-185.03-158.59-116.15z"
                    transform="matrix(-.45 0 0 .64 567.65 -59.76)"
                    stroke="#000"
                    fill="#ffdf00"
                />
                <path
                    d="M344.46 304.2c0 17.717-7.846 269.82 27.587 269.82s88.583-17.717 88.583-17.717l-.86-167.31-115.31-84.79z"
                    transform="matrix(-.45 0 0 .64 567.65 -59.76)"
                    stroke="#000"
                    fill="#0000c4"
                />
                <path
                    d="M367.52 321.16c0 17.717 4.525 217.42 39.958 217.42h53.15l-.86-149.59-92.248-67.833z"
                    transform="matrix(-.45 0 0 .64 567.65 -59.76)"
                    stroke="#000"
                    fill="#e10000"
                />
                <path d="M433.814 116.02l-72.423 76.485-1.276-1.642 72.423-76.485 1.277 1.642z" />
                <g stroke="#000" fill="#005b00">
                    <path
                        d="M428.17-16.928s81.556 90.618 111.01 154.05c29.45 63.432 54.37 156.32 54.37 156.32s2.266-86.086-36.246-163.11c-52.1-97.42-131.4-142.73-129.13-147.26z"
                        transform="matrix(.16 -.07 .08 .35 309.51 210.98)"
                    />
                    <path
                        d="M428.17-16.928s81.556 90.618 111.01 154.05c29.45 63.432 54.37 156.32 54.37 156.32s2.266-86.086-36.246-163.11c-52.1-97.42-131.4-142.73-129.13-147.26z"
                        transform="matrix(.2 -.05 .07 .4 291.49 182.57)"
                    />
                    <path
                        d="M428.17-16.928s81.556 90.618 111.01 154.05c29.45 63.432 54.37 156.32 54.37 156.32s2.266-86.086-36.246-163.11c-52.1-97.42-131.4-142.73-129.13-147.26z"
                        transform="matrix(.23 .14 -.03 .4 296.48 69.41)"
                    />
                    <path
                        d="M428.17-16.928s81.556 90.618 111.01 154.05c29.45 63.432 54.37 156.32 54.37 156.32s2.266-86.086-36.246-163.11c-52.1-97.42-131.4-142.73-129.13-147.26z"
                        transform="matrix(.25 .03 .02 .44 274.4 114.91)"
                    />
                    <path
                        d="M428.17-16.928s81.556 90.618 111.01 154.05c29.45 63.432 54.37 156.32 54.37 156.32s2.266-86.086-36.246-163.11c-52.1-97.42-131.4-142.73-129.13-147.26z"
                        transform="matrix(.18 .17 -.04 .35 329.99 66.98)"
                    />
                    <path
                        d="M428.17-16.928s81.556 90.618 111.01 154.05c29.45 63.432 54.37 156.32 54.37 156.32s2.266-86.086-36.246-163.11c-52.1-97.42-131.4-142.73-129.13-147.26z"
                        transform="matrix(.23 0 .03 .4 280.58 141.86)"
                    />
                    <path
                        d="M428.17-16.928s81.556 90.618 111.01 154.05c29.45 63.432 54.37 156.32 54.37 156.32s2.266-86.086-36.246-163.11c-52.1-97.42-131.4-142.73-129.13-147.26z"
                        transform="matrix(.2 -.07 .07 .38 290.14 196.84)"
                    />
                    <path
                        d="M428.17-16.928s81.556 90.618 111.01 154.05c29.45 63.432 54.37 156.32 54.37 156.32s2.266-86.086-36.246-163.11c-52.1-97.42-131.4-142.73-129.13-147.26z"
                        transform="matrix(.2 -.03 .05 .4 292.69 166.78)"
                    />
                    <path
                        d="M428.17-16.928s81.556 90.618 111.01 154.05c29.45 63.432 54.37 156.32 54.37 156.32s2.266-86.086-36.246-163.11c-52.1-97.42-131.4-142.73-129.13-147.26z"
                        transform="matrix(.22 .15 -.05 .38 305.08 65.51)"
                    />
                    <path
                        d="M428.17-16.928s81.556 90.618 111.01 154.05c29.45 63.432 54.37 156.32 54.37 156.32s2.266-86.086-36.246-163.11c-52.1-97.42-131.4-142.73-129.13-147.26z"
                        transform="matrix(.24 .05 0 .44 278.88 97.67)"
                    />
                    <path
                        d="M428.17-16.928s81.556 90.618 111.01 154.05c29.45 63.432 54.37 156.32 54.37 156.32s2.266-86.086-36.246-163.11c-52.1-97.42-131.4-142.73-129.13-147.26z"
                        transform="matrix(.17 .17 -.06 .33 338.96 70)"
                    />
                    <path
                        d="M428.17-16.928s81.556 90.618 111.01 154.05c29.45 63.432 54.37 156.32 54.37 156.32s2.266-86.086-36.246-163.11c-52.1-97.42-131.4-142.73-129.13-147.26z"
                        transform="matrix(.24 .02 0 .4 276.43 128.02)"
                    />
                </g>
                <path
                    d="M301.18 272.84s-35.433 336.61 70.866 336.61c88.583 0 88.583-53.15 106.3-53.15l-17.72-124.02-159.45-159.44z"
                    transform="matrix(-.58 0 0 .62 630.39 -10.18)"
                    stroke="#000"
                    fill="#ffdf00"
                />
                <path
                    d="M336.61 308.27c0 17.717-35.433 212.6 53.15 265.75 35.433 17.716 88.582-17.717 88.582 0l-17.71-141.74-124.02-124.01z"
                    transform="matrix(-.58 0 0 .62 630.39 -10.18)"
                    stroke="#000"
                    fill="#0000c4"
                />
                <path
                    d="M372.05 343.7c0 17.717-17.716 159.45 35.433 194.88 35.433 35.433 124.02 25.822 124.02 25.822l-70.87-132.12-88.58-88.58z"
                    transform="matrix(-.58 0 0 .62 630.39 -10.18)"
                    stroke="#000"
                    fill="#e10000"
                />
                <path d="M456.172 158.08l-94.777 99.91-1.66-1.573 94.775-99.91 1.662 1.574z" />
                <path
                    d="M460.63 184.25l17.716 35.433V237.4c-.865-1.305 0 17.716-17.716 17.716-17.717 0-17.717-35.433-17.717-35.433s-17.716 35.433-17.716 70.866 17.716 53.15 17.716 53.15-2.61-36.704 17.717-35.434c20.328 1.27 17.716 17.716 17.716 17.716v35.433h17.717v-141.73l17.717-35.433-27.136-53.15-26.014 53.15z"
                    transform="matrix(-.14 -.14 -.1 .1 553.66 192.15)"
                    stroke="#000"
                    fill="#cececc"
                />
                <path
                    d="M557.82 95.67l-26.323 70.865 17.717 53.15-35.433-17.716 35.434 53.148v35.433h17.716v-35.43l35.433-53.15-35.433 17.717 17.717-53.15L557.82 95.67z"
                    transform="matrix(-.1 -.16 -.14 .1 526.03 183.83)"
                    stroke="#000"
                    fill="#cececc"
                />
                <path
                    d="M422.53 136.96c0 2.068-1.958 3.746-4.37 3.746-2.413 0-4.372-1.678-4.372-3.746s1.96-3.747 4.37-3.747c2.414 0 4.372 1.68 4.372 3.747zm-6.244 7.91c0 35.8 20.917 187.81 22.582 191.56.14 4.44-4.718 6.382-7.077.832-6.55-17.342-20.743-159.91-21.332-193.22-.244-13.734 3.76-14.8 8.326-14.57 3.76.21 8.325 3.725 8.325 7.91 0 4.995-5.83 8.74-10.824 7.492z"
                    transform="matrix(-.4 0 0 .3 596.29 69.8)"
                    stroke="#000"
                    fill="#e10000"
                />
                <path
                    d="M422.53 136.96c0 2.068-1.958 3.746-4.37 3.746-2.413 0-4.372-1.678-4.372-3.746s1.96-3.747 4.37-3.747c2.414 0 4.372 1.68 4.372 3.747zm-6.244 7.91c31.488 61.414 48.722 166.77 50.387 170.52.14 4.44-4.718 6.382-7.077.832-2.48-3.315-12.667-100.18-49.138-172.18-.244-13.734 3.76-14.8 8.326-14.57 3.76.21 8.325 3.725 8.325 7.91 0 4.995-5.83 8.74-10.824 7.492z"
                    transform="matrix(-.38 .1 .15 .3 563.96 38.16)"
                    stroke="#000"
                    fill="#0000c4"
                />
                <path
                    d="M453.345 151.54c0 1.034.979 1.873 2.185 1.873 1.207 0 2.186-.839 2.186-1.873s-.98-1.873-2.185-1.873c-1.207 0-2.186.84-2.186 1.873zm3.122 3.955c0 17.9-10.458 93.905-11.291 95.78-.07 2.22 2.359 3.191 3.539.416 3.275-8.671 10.371-79.955 10.666-96.61.122-6.867-1.88-7.4-4.163-7.285-1.88.105-4.163 1.863-4.163 3.955 0 2.498 2.915 4.37 5.412 3.746z"
                    stroke="#000"
                    fill="#e10000"
                    strokeWidth=".5pt"
                />
                <path
                    d="M422.53 136.96c0 2.068-1.958 3.746-4.37 3.746-2.413 0-4.372-1.678-4.372-3.746s1.96-3.747 4.37-3.747c2.414 0 4.372 1.68 4.372 3.747zm-6.244 7.91c31.488 61.414 48.722 166.77 50.387 170.52.14 4.44-4.718 6.382-7.077.832-2.48-3.315-12.667-100.18-49.138-172.18-.244-13.734 3.76-14.8 8.326-14.57 3.76.21 8.325 3.725 8.325 7.91 0 4.995-5.83 8.74-10.824 7.492z"
                    transform="matrix(-.48 .15 .2 .48 623.32 31.58)"
                    stroke="#000"
                    fill="#0000c4"
                />
            </g>
            <g fillRule="evenodd" stroke="#000" strokeWidth="1pt">
                <path
                    d="M478.35 698.03c17.717 10.652 37.09 8.268 53.15 0V556.3h-35.433c17.717 53.15 17.717 106.3-17.717 141.73z"
                    fill="#e10000"
                    transform="matrix(.58 0 0 .62 9.63 -10.18)"
                />
                <path
                    d="M513.78 609.45c0 88.582-42.466 108.27-42.466 125.98 17.716 0 29.465-8.248 42.466-19.685 17.716-17.717 19.426-107.68 17.716-106.3H513.78z"
                    transform="matrix(.35 0 0 .7 123.48 -89.93)"
                    fill="#0000c4"
                />
                <path
                    d="M478.35 609.45c-.81 51.77-44.794 99.64-36.497 110.24 9.474 9.475 36.497-21.654 71.93-3.937 17.717-17.717 19.427-107.68 17.717-106.3h-53.15z"
                    transform="matrix(.35 0 0 .7 123.48 -89.93)"
                    fill="#0000c4"
                />
                <path
                    d="M513.78 609.45c0 88.582-40.696 94.47-40.696 118.09 17.717 0 40.603-12.912 40.696-11.79 17.716-17.718 19.426-107.68 17.716-106.3H513.78z"
                    transform="matrix(.35 0 0 .46 112.52 51)"
                    fill="#ffdf00"
                />
                <path
                    d="M478.35 609.45c-.81 51.77-43.73 95.702-35.433 106.3 9.474 9.475 35.433-17.717 70.867 0 17.716-17.717 19.426-107.68 17.716-106.3h-53.15z"
                    transform="matrix(.35 0 0 .46 112.52 51)"
                    fill="#ffdf00"
                />
                <path
                    d="M478.35 698.03c17.717 10.652 37.09 8.252 53.15-.015v-141.72h-35.433c17.717 53.15 17.717 106.3-17.717 141.73z"
                    transform="matrix(-.58 0 0 .62 630.39 -10.17)"
                    fill="#e10000"
                />
                <path
                    d="M513.78 609.45c0 88.582-42.466 108.27-42.466 125.98 17.716 0 29.465-8.248 42.466-19.685 17.716-17.717 19.426-107.68 17.716-106.3H513.78z"
                    transform="matrix(-.35 0 0 .7 516.53 -89.92)"
                    fill="#0000c4"
                />
                <path
                    d="M478.35 609.45c-.81 51.77-44.794 99.64-36.497 110.24 9.474 9.475 36.497-21.654 71.93-3.937 17.717-17.717 19.427-107.68 17.717-106.3h-53.15z"
                    transform="matrix(-.35 0 0 .7 516.53 -89.92)"
                    fill="#0000c4"
                />
                <path
                    d="M513.78 609.45c0 88.582-40.696 94.47-40.696 118.09 17.717 0 40.603-12.912 40.696-11.79 17.716-17.718 19.426-107.68 17.716-106.3H513.78z"
                    transform="matrix(-.35 0 0 .46 527.51 51.01)"
                    fill="#ffdf00"
                />
                <path
                    d="M478.35 609.45c-.81 51.77-43.73 95.702-35.433 106.3 9.474 9.475 35.433-17.717 70.867 0 17.716-17.717 19.426-107.68 17.716-106.3h-53.15z"
                    transform="matrix(-.35 0 0 .46 527.51 51)"
                    fill="#ffdf00"
                />
            </g>
            <g stroke="#000" fillRule="evenodd">
                <path
                    d="M198.56 77.952l-89.676 35.434 89.676 35.434 44.837-17.717 22.42 17.717 22.418 35.433 22.42-35.433 22.418-17.717 1201.9-.002V95.668l-1201.9.002-22.42-17.718c0-17.716 4.704-35.433 22.42-35.433 17.717 0 54.242-.003 89.675-.003 0-17.716-44.838-53.15-134.51-53.15-89.675 0-134.51 35.434-134.51 53.15l89.675.002c17.716 0 22.42 17.716 22.42 35.432l-22.44 17.717-44.84-17.717z"
                    transform="matrix(.12 0 0 .22 217.8 324.36)"
                    strokeWidth={4.467}
                    fill="#908f8a"
                />
                <path
                    transform="matrix(.28 0 0 .27 216.06 334.6)"
                    strokeWidth={1.838}
                    fill="#b74d00"
                    d="M204.35 95.67h336.61v17.718H204.35z"
                />
                <path
                    transform="matrix(.28 0 0 .27 216.06 334.6)"
                    strokeWidth={1.838}
                    fill="#b74d00"
                    d="M204.35 77.955h336.61v17.717H204.35zm0-17.718h336.61v17.717H204.35z"
                />
                <path
                    transform="matrix(.28 0 0 .27 216.06 334.6)"
                    strokeWidth={1.838}
                    fill="#b74d00"
                    d="M204.35 42.522h336.61V60.24H204.35zm0-17.717h336.61v17.717H204.35z"
                />
                <path
                    transform="matrix(.28 0 0 .27 216.06 334.6)"
                    strokeWidth={1.838}
                    fill="#b74d00"
                    d="M204.35 7.09h336.61v17.716H204.35zm0-17.718h336.61V7.09H204.35z"
                />
                <path
                    d="M423.23 60.236l137.8 124.02h19.686l-137.8-124.02H423.23z"
                    transform="matrix(.25 0 0 .27 171.89 315.18)"
                    strokeWidth={3.255}
                    fill="#908f8a"
                />
                <path
                    d="M423.23 60.236l137.8 124.02h19.686l-137.8-124.02H423.23z"
                    transform="matrix(.25 0 0 -.27 171.89 382.19)"
                    strokeWidth={3.255}
                    fill="#908f8a"
                />
                <path
                    d="M425.2 60.236v124.02h17.716V60.236H425.2z"
                    transform="matrix(.28 0 0 .27 159.56 315.18)"
                    strokeWidth={3.087}
                    fill="#908f8a"
                />
                <path
                    d="M423.23 60.236l137.8 124.02h19.686l-137.8-124.02H423.23z"
                    transform="matrix(.25 0 0 .27 216.23 315.18)"
                    strokeWidth={3.255}
                    fill="#908f8a"
                />
                <path
                    d="M423.23 60.236l137.8 124.02h19.686l-137.8-124.02H423.23z"
                    transform="matrix(.25 0 0 -.27 216.23 382.19)"
                    strokeWidth={3.255}
                    fill="#908f8a"
                />
                <path
                    d="M425.2 60.236v124.02h17.716V60.236H425.2z"
                    transform="matrix(.28 0 0 .27 238.4 315.18)"
                    strokeWidth={3.087}
                    fill="#908f8a"
                />
                <path
                    d="M425.2 60.236v124.02h17.716V60.236H425.2z"
                    transform="matrix(.28 0 0 .27 203.91 315.18)"
                    strokeWidth={3.087}
                    fill="#908f8a"
                />
                <path
                    d="M425.2 60.236v124.02h17.716V60.236H425.2z"
                    transform="matrix(.28 0 0 .27 194.05 315.18)"
                    strokeWidth={3.087}
                    fill="#908f8a"
                />
            </g>
            <g stroke="#000" strokeWidth="1pt" fill="#ffdf00" fillRule="evenodd">
                <path
                    d="M655.51 396.85c0 88.016-55.56 159.45-124.02 159.45-68.456 0-124.02-71.433-124.02-159.45 0-88.015 55.56-159.45 124.02-159.45 68.457 0 124.02 71.433 124.02 159.45zm-17.717 0c0 78.237-47.622 141.73-106.3 141.73-58.677 0-106.3-63.495-106.3-141.73 0-78.236 47.622-141.73 106.3-141.73 58.677 0 106.3 63.497 106.3 141.73z"
                    transform="matrix(.58 0 0 .62 9.63 -10.18)"
                />
                <path
                    d="M579.75 249.94c-14.836-8.072-31.144-12.537-48.258-12.537s-33.422 4.465-48.257 12.537l6.893 16.323c12.716-7.175 26.695-11.144 41.364-11.144s28.648 3.968 41.364 11.143l6.894-16.323z"
                    transform="matrix(.58 0 0 .62 9.63 -10.18)"
                />
                <path
                    d="M579.75 249.94c-14.836-8.072-31.144-12.537-48.258-12.537s-33.422 4.465-48.257 12.537l6.893 16.323c12.716-7.175 26.695-11.144 41.364-11.144s28.648 3.968 41.364 11.143l6.894-16.323z"
                    transform="matrix(.58 0 0 -.62 9.75 479.31)"
                />
            </g>
            <path
                d="M379.554 235.867c0 48.532-27.603 87.873-61.654 87.873-34.05 0-61.654-39.343-61.654-87.873 0-48.532 27.603-87.873 61.654-87.873 34.05 0 61.654 39.343 61.654 87.873z"
                fillRule="evenodd"
                fill="#a7cfff"
            />
            <path
                d="M637.8 396.85c1.133 26.658-4.634 39.635-11.89 67.356-1.912 2.98-10.966-6.537-16.447-11.236s-7.812 4.24-14.537-3.046c-6.725-7.284-11.05 2.058-15.983-4.095s-51.3-7.057-51.366-7.586c4.59-2.276 28.27.152 24.474-11.193-4.3-11.72-31.093-.35-34.69-15.364-2.44-14.907-53.567-15.543-57.22-19.225 1.444 5.665 39.728 8.05 38.814 22.57-.833 5.916-37.693 7.645-41.247 12.652-3.045 6.295 28.927-1.707 30.114 6.032-.077 3.185-4.704.068-21.357 4.99-8.326 2.46 15.454 10.33 6.41 14.637-9.045 4.308-28.26 6.188-27.433 7.998 2.94 8.908 44.693 19.536 40.535 21.065-14.754 6.56-22.552 10.872-29.627 14.652-19.24-25.653-31.146-61.087-31.146-100.2 31.716-11.405 24.968-13.735 83.645-13.735s77.98 2.33 128.95 13.735z"
                fillRule="evenodd"
                stroke="#000"
                strokeWidth="1pt"
                fill="#afff7b"
                transform="matrix(.58 0 0 .62 9.63 -10.18)"
            />
            <path
                d="M637.8 396.85c-8.07 0-16.454 3.4-25.07 3.4-8.617 0-17.465-3.4-26.466-3.4s-19.287 4.532-28.512 4.532c-9.224 0-17.388-4.53-26.676-4.53-9.287 0-18.566 3.397-27.755 3.397s-18.288-3.4-27.218-3.4-17.69 3.4-26.2 3.4-16.77-3.4-24.7-3.4c0-19.56 2.976-38.197 8.358-55.15 27.075 2 11.042-15.716 27.075-15.716 8.655 0 17.434 1.86 25.238 9.788 2.447 0 14.48-11.373 27.912-9.788 13.432 1.586 8.492 27.272 26.37 28.637 9.063 6.797 14.393 11.134 26.78 13.872 17.716 1.606 68.35-2.5 68.704-.194a188.21 188.21 0 012.16 28.552z"
                fillRule="evenodd"
                stroke="#000"
                strokeWidth="1pt"
                fill="#fff"
                transform="matrix(.58 0 0 .62 9.63 -10.18)"
            />
            <path
                d="M549.85 473.94c0-5.664 13.512-9.462 13.512-18.524s-11.914-9.35-12.38-17.86c-.2-3.46 10.32-7.046 14.915-7.335s8.493 7.42 8.493 9.12-4.662-4.192-8.578-4.378-12.313.63-12.313 2.33c0 3.4 14.85 7.598 13.717 18.925-1.132 11.327-12.71 14.657-12.71 18.055s5.056 12.86 5.056 12.86-9.713-7.53-9.713-13.192z"
                fillRule="evenodd"
                transform="matrix(.2 0 0 .48 217.23 59.5)"
                stroke="#000"
                strokeWidth="1pt"
            />
            <path
                d="M549.85 473.94c0-5.664 13.512-9.462 13.512-18.524s-11.95-9.348-12.38-17.86c-.946-3.962 11.814-6.544 16.41-6.833s9.985 7.92 9.985 9.62-5.41-5.195-9.325-5.38-14.553.63-14.553 2.33c0 3.398 14.85 7.597 13.717 18.924-1.132 11.327-12.71 14.657-12.71 18.055s5.056 12.86 5.056 12.86-9.713-7.53-9.713-13.192z"
                fillRule="evenodd"
                transform="matrix(-.2 0 0 .48 445.83 59.12)"
                stroke="#000"
                strokeWidth="1pt"
            />
            <path
                d="M332.965 264.846c0 1.333-.65 2.413-1.454 2.413-.803 0-1.454-1.08-1.454-2.414s.65-2.413 1.455-2.413c.804 0 1.455 1.08 1.455 2.413zm16.951 8.964h.465v19.617h-.464zm4.182-1.487h.464v19.616h-.464z"
                fillRule="evenodd"
            />
            <path fillRule="evenodd" d="M352.597 281.23l.004-.493 3.978.684-.004.495z" />
            <path
                d="M497.26 478.07s26.052 11.328 31.716 18.124c5.664 6.797 3.398 6.796 3.398 6.796l57.77 2.266c0-3.398 10.193-3.4 12.46-11.328 2.264-7.93 2.264-10.194 2.264-10.194l-18.123 5.664 1.132-10.194H572.02l-2.266 10.194-33.982-1.133 2.266-27.186-6.796 1.132-1.133 26.053c-1.134 0-31.718-7.93-32.85-10.195z"
                fillRule="evenodd"
                transform="matrix(.58 0 0 .62 6.99 -9.48)"
                stroke="#000"
                strokeWidth="1pt"
                fill="#b74d00"
            />
            <path
                d="M440.53 316.28s37.645-11.214 92.11-10.413 92.11 12.815 91.31 12.815-10.414-18.422-10.414-18.422-38.446-10.412-81.697-11.213c-43.253-.8-80.898 8.01-80.097 8.81L440.53 316.28z"
                fillRule="evenodd"
                stroke="#fede00"
                strokeWidth="1pt"
                fill="#fede00"
                transform="matrix(.58 0 0 .62 9.63 -10.18)"
            />
            <path
                fillRule="evenodd"
                fill="#38a9f9"
                d="M306.072 169.855l13.562-.262.137 7.9-13.56.264zm-31.297 4.3l-4.783 7.784 16.165-1.992-1.297-7.783-10.085 1.99zm13.778-2.995l13.518-1.187.62 7.876-13.516 1.187zm48.837-.806l-13.538-.91-.475 7.888 13.537.91zm29.182 4.953l4.918 9.69-14.642-3.614 1.63-7.714 8.094 1.637zm-11.736-2.817l-13.453-1.83-.957 7.837 13.453 1.832z"
            />
            <path
                fillRule="evenodd"
                stroke="#000"
                strokeWidth="1pt"
                fill="#ffdf00"
                d="M532.64 323.49l-2.58-13.47-7.54 11.46 2.77-13.43-11.34 7.7 7.7-11.35-13.43 2.78 11.45-7.54-13.47-2.58 13.47-2.58-11.45-7.53 13.43 2.77-7.7-11.35 11.34 7.7-2.77-13.43 7.54 11.46 2.58-13.47 2.57 13.47 7.54-11.46-2.77 13.43 11.35-7.7-7.71 11.35 13.44-2.77-11.46 7.53 13.47 2.58-13.47 2.58 11.46 7.54-13.44-2.78 7.71 11.35-11.35-7.7 2.77 13.43-7.54-11.46z"
                transform="matrix(.58 0 0 .62 9.63 -10.18)"
            />
            <path
                d="M547.05 293.86c0 9.29-6.634 16.82-14.818 16.82s-14.818-7.53-14.818-16.82 6.634-16.82 14.818-16.82 14.818 7.53 14.818 16.82z"
                fillRule="evenodd"
                transform="matrix(.57 0 0 .5 18.27 21.75)"
                stroke="#000"
                strokeWidth="1pt"
                fill="#ffdf00"
            />
            <path
                d="M320.676 170.552c0 .545-1.257.988-2.807.988s-2.807-.443-2.807-.988 1.256-.988 2.806-.988 2.806.442 2.806.988zm6.079-.002c0 .547-.943.99-2.105.99s-2.105-.443-2.105-.99c0-.544.942-.987 2.105-.987s2.105.443 2.105.988z"
                fillRule="evenodd"
            />
            <path
                d="M529.43 297.86l.8.8c-1.9-1.9-.995-1.125 1.603 3.204 2.393-.495 3.09-1.39 4.806-2.403"
                transform="matrix(.56 -.18 .17 .6 -26.71 90.63)"
                stroke="#000"
                strokeWidth="1pt"
                fill="none"
            />
            <path
                d="M527.83 304.27l.8.8c-1.9-1.9-1.123-.994 3.205 1.603 4.027.544 8.092-1.196 10.412-4.005"
                transform="matrix(.58 0 0 .62 8.7 -10.18)"
                stroke="#000"
                strokeWidth="1pt"
                fill="none"
            />
            <path
                d="M281.395 194.854s.93 7.945-5.11 17.877c-6.04 9.933-5.11 6.457-5.11 6.457s2.787 5.462 2.323 5.462-4.646-4.966-4.646-4.966l-5.11 5.462s4.646-8.442 4.18-8.442-1.393-2.98-1.393-2.98l3.715-1.49s5.575-10.428 5.575-9.93-16.724 11.42-16.724 11.42l22.3-18.87zm3.718 2.982c-.465 0 2.322 7.946 4.645 11.918 2.323 3.973 2.323 8.94 2.323 8.94l7.9 3.972-10.222-15.394 6.504 2.482-11.15-11.918zm0 20.857s5.574 5.96 6.04 7.945.463 6.456.463 6.456l-2.322-4.966-3.252 4.47s2.323-6.953 1.858-7.45-3.717 2.484-3.717 2.484 1.394-3.973 1.394-4.47 0-2.98-.464-4.47zm-27.875 13.9c1.858-1.49 5.574-2.482 5.574-2.482s-2.323 3.973-2.787 3.973-1.858 0-2.787-1.49zm64.107-21.848s12.078 7.45 12.078 7.946-7.897-3.476-7.897-3.476l-4.18-4.47zm-21.831-15.395c.93.497 17.653 14.4 17.188 14.4s-7.432-3.972-7.432-3.475v3.476l-3.717-7.945-.93 2.98-5.11-9.435zm4.176 22.345l4.646 9.435 4.645-.993s-8.825-8.442-9.29-8.442zm14.407-5.958c0 1.49.465 8.938.465 8.938s2.787 2.483 2.787 1.987-2.788-10.43-3.253-10.925z"
                fillRule="evenodd"
                fill="#b7e1ff"
            />
            <path
                d="M182.612 89.522s20.98-11.61 44.87-20.254c23.886-8.644 50.68-14.325 54.222-14.325 7.077 0 19.21 17.783 21.233 17.783 2.022 0 10.11-4.94 20.223-4.94s16.178 7.904 18.2 7.904h18.2c2.023 0-6.066-19.76 0-18.77 3.034.493 28.817 4.445 52.833 12.225 24.014 7.78 58.103 21.515 58.103 21.515s-55.714 7.44-70.488 5.24c-2.022.988-.1 13.07-2.933 7.754-4.656-1.063-21.744-3.727-24.778-3.727s-8.69 3.427-16.78 5.402c-8.088 1.976-18.2 4.94-18.2 4.94l13.146 20.747-16.178 7.903s-10.11-23.71-14.156-23.71-6.067 16.795-11.123 15.807c-5.056-.988-7.078-15.808-11.123-19.76-4.044-3.95-25.368-5.39-33.458-7.366-8.09-1.975-21.144-3.5-28.222-5.476-7.078-1.976-14.155 4.94-17.19 4.94-3.032 0 4.046-5.928 1.012-6.916s-5.055 2.964-7.078 2.964c-2.022 0-23.256-3.952-25.278-4.94-2.022-.988 5.056-4.94 3.034-4.94h-8.09z"
                fillRule="evenodd"
                fill="#984000"
            />
            <path
                d="M462.91-64.94c0 21.15-20.5 38.298-45.79 38.298S371.327-43.79 371.327-64.94s20.5-38.298 45.79-38.298S462.91-86.09 462.91-64.94z"
                fillRule="evenodd"
                transform="matrix(.22 0 0 .26 231.63 96.52)"
                stroke="#772600"
                strokeWidth={3.706}
                fill="gray"
            />
            <path
                d="M284.74-59.945c6.66-6.66 14.987-16.65 36.633-16.65 4.996-1.666 4.996-11.657 16.65-11.657 11.657 0 8.327 9.99 16.653 13.32 8.325 3.33 76.596-3.33 76.596-3.33s6.66 4.996 6.66 11.657c0 6.66-4.995 11.656-6.66 11.656s-68.27-4.995-73.266-3.33c-4.995 1.666-8.326 3.33-19.982 3.33-11.655 0-14.986-11.655-23.31-11.655-8.327 0-16.653-1.665-29.974 6.66z"
                fillRule="evenodd"
                transform="matrix(.27 0 0 .32 205.39 100.65)"
                stroke="#772600"
                strokeWidth={5.25}
                fill="#984000"
            />
            <path
                d="M487.88-76.597h26.642c9.572.114 12.873 3.005 21.647 3.33h23.31c8.476-.314 12.952-2.295 21.648-3.33 14.504-.175 9.555-1.306 6.66-9.99-2.625-6.565-2.95-9.61-6.66-13.322-1.396-7.944-4.655-10.77-4.996-19.98-1.527-7.027-4.342-11.753-1.665-19.983 3.84 5.647 5.387 7.97 14.986 8.326 10.045 0 13.937-.206 19.982 3.33 4.663 4.89 10.886 3.33 19.982 3.33 7.677 1.406 8.96 5.313 14.986 8.326 7.103 3.935 11.694 4.995 21.646 4.995 7.967 1.422 14.88 2.578 19.98 4.995 4.25 5.08 10.952 6.338 19.983 6.66 5.05 0 8.95-.524 13.32-1.665 7.678.37 15.474 0 24.978 0 6.163 7.21 7.587 9.862 18.317 9.99 7.338 5.155 13.527 6.037 19.982 8.327h24.976c8.928.687 11.79 4.35 19.98 6.66 8.115 3.768 15.722 6.35 21.648 8.326 5.89 1.28 13.574 1.665 21.646 1.665 6.183 3.175 13.61 3.46 18.317 6.66 6.89 1.477 16.302 3.215 21.647 4.996 8.816 1.168 12.187 3.94 19.98 4.995 6.704 1.915-2.223 3.56-6.66 4.995-9.826-.364-10.536-3.946-19.98-4.995-5.024-2.94-12.64-2.548-19.982-4.996h-1.666c6.6 3.903 12.948 6.422 9.99 13.32-8.49 0-15.366-1.097-23.31-1.665-8.385-1.616-12.227-3.33-21.647-3.33 9.394-2.264 11.854.27 18.315 3.33 2.396 8.06-2.725 4.996-11.656 4.996-7.61-2.73-12.174-5.983-21.648-6.66h-19.98c9.89.366 11.976 4.1 18.315 8.326.518 2.59-.132 2.472-4.995 3.33-5.16-4.478-11.89-6.013-19.982-8.326-7.88-.28-16.217-.965-23.31-3.33-4.868-.304-4.117-6.177 6.66 3.33 6.532 3.843 8.832 6.946 8.325 9.99-8.576-2.143-12.825-5.58-18.317-8.324-7.736-2.855-14.128-3.33-23.312-3.33-8.61-2.266.894-3.574 6.66 4.995 12.38 8.77-1.632 5.007-6.66 3.33-7.507-2.144-15.284-5.184-21.646-6.66-5.046-1.44-9.44-2.855-14.986-3.33 8.63.785 11.57 3.823 14.986 9.99 8.755 6.032-.384 3.1-8.326 1.666-5.07-4.402-11.487-6.658-14.986-11.656-8.35-4.176-8.563-8.982-3.33 1.665 1.363 3.407 1.11 10.795 1.665 11.656-6.136-6.625-4.825-8.325-11.656-8.325-4.634-3.244-11.496-5.765-14.986-9.99-6.435-.604-6.84-2.9-13.32-4.996 5.34 6.273 12.39 12.478 16.65 18.315 7.598 4.242 9.7 8.06 14.987 11.656 2.14 3.64 7.904 6.657 1.665 1.666-7.144-7.043-12.46-8.67-23.312-13.32-6.15-4.96-8.37-7.045-14.986-11.657-9.003-2.905-5.508-4.543 0 4.995 6.318 5.77 11.17 12.23 16.652 16.65 3.767 4.908 10.136 10.12 14.986 13.322 1.5 2.25 5.99 2.664 0 3.33-5.09-4.598-12.398-7.53-18.317-11.656-8.302-2.34-12.19-6.652-18.316-11.655-3.9-5.85-10.383-10.38-14.987-14.986-9.63-3.77 1.9 3.636 4.995 8.325 2.153 6.068 4.788 11.035 6.66 16.65 2.78 5.56-8.47-1.327-11.655-3.33-7.32-4.157-12.674-6.937-21.647-8.325-5.98-1.3-13.602-2.468-19.982-3.33-7.614-2.05 4.042 4.8 8.326 11.656 8.418 7.908-8.332 1.425-13.32 0-8.224-1.645-16.288-1.666-24.978-1.666-10.67.628-3.05 1.947 0 6.66 3.287 2.53 5.637 7.855 4.995 9.992-7.032-.95-13.025-3.023-21.646-3.33-6.96 2.32-15.344 1.665-23.31 1.665-.382 4.19 1.443.654 4.994 4.995 5.763 2.34 9.585 5.177 8.326 8.326H497.87c-5.29 1.447 1.14.704 5 6.663-2.16 5.403-4.95 3.332-11.655 3.332-4.545-1.818-13.598-2.636-18.317-4.996-4.69 0-4.336-1.22-8.325-1.665 14.035 9.93 7.073 7.45 14.986 14.987 1.366.456 4.523 1.665 1.664 1.665M371.32 73.265c-.997 0-3.2-5.375-6.66-9.99-2.327-6.05-5.392-2.59-8.326-11.657.348-9.402.684-11.094 0-19.982-6.863-4.783-9.714-6.27-14.986-14.986-8.46-7.078 1.236-19.063 2.845-27.85-7.375-1.638-11 11.477-22.34 16.194-8.156 5.492-.912-11.354-4.892-21.188-2.774-13.872-10.825 6.956-13.91 12.862-5.467 3.718-7.128 8.542-14.986 1.665 0-5.144 4.937-19.49 2.845-22.28-7.815 3.815-18.088 15.49-26.158 17.284-8.13-1.767 1.77-14.828 1.77-24.518-2.938-.98-14.696 25.755-19.52 26.002-4.824.248-2.713-25.993-4.972-25.428-3.542 4.96-10.65 15.43-15.576 18.948-9.454-1.22 1.398-17.435 2.845-23.427 1.628-7.168-8.905 13.75-14.502 15.102-4.1 3.554-12.237 6.072-14.986 6.66 3.24-6.13 19.076-18.712 17.935-22.278-9.21.34-23.31 12.556-31.256 13.952-5.19 0-12.387 1.758-13.32 1.665.448-7.926 19.418-14.65 22.445-19.465-9.306 1.494-27.186 9.706-32.436 16.135-6.146 1.336-13.944 3.02-19.983 0 .897-7.475 14.856-21.998 17.936-26.758-8.396 3.697-12.642 6.59-21.647 8.325-1.652 1.652-6.524 5.23-4.995 1.665 2.656-6.945 6.676-10.11 9.99-14.986-7.45 1.364-10.28 5.634-18.315 9.99-5.094.222-19.646 14.855-24.596 15.103-11.45 8.382-16.01 9.807-28.308 13.32-7.587 1.356-11.26 2.934-14.986 6.66 3.796-6.687 9.597-13.092 14.986-16.65 3.677-5.567 7.12-10.195 14.986-13.32 1.897-2.32 7.188-2.906 1.665-3.33-4.746 4.236-12.696 8.965-16.65 11.655-5.102 3.207-11.01 6.48-13.322 4.995 2.62-7.197 7.438-8.902 11.657-14.986 8.81-5.604.042-1.914-6.66 0-4.338 3.868-12.122 6.727-18.316 9.992-7.113 1.856-11.703 6.132-19.98 8.326 0 2.375 2.364-4.25 3.33-6.66 6.83-7.41 8.656-9.476 16.65-11.657 1.912-2.866 4.42-1.664-1.665-1.664-4.514 4.024-10.81 6.212-16.65 9.99-5.892 1.282-13.575 1.666-21.648 1.666-10.355 1.243-9.46 2.025 0-3.33 5.357-5.042 9.77-3.775 9.99-9.99C10.394-40.43 2.78-37.1-4.998-33.304c-6.434.19-8.133 1.665-14.985 1.665 3.298-3.415 5.277-7.633 9.99-9.99 6.896-7.663-4.377-1.478-6.66 0H-41.63c-4.465 5.58-.23.05 3.33-3.33 4.306-2.24 8.756-5.155 8.326-6.66-4.972 4.314-10.726 6.297-14.986 9.99-4.64 1.39-9.99 2.084-9.99 3.33 3.626-5.346 9.524-8.576 13.32-13.32 5.612-1.22 10.396-2.936 11.656-4.996h-23.312 16.65c8.4 0 15.63-.75 23.313-1.665 13.263-2.21-1.16-3.33-8.326-3.33-1.39-2.548 4.11-3.987 9.99-4.995 5.024-2.38 11.233-4.493 16.65-6.66 5.257-1.434 12.707-5.81 13.322-6.66-5.015.263-4.975 1.4-9.99 1.664 7.446-.574 12.8-1.666 21.646-1.666 8.028-2.58 14.906-5.41 21.647-8.326 2.936-3.588 4.24-3.33-3.33-3.33 6.713-2.158 16.238-3.193 21.647-4.995 7.872-1.687 14.9-4.253 19.982-6.66 4.876-3.316 7.69-7.176 13.32-9.99 6.528 4.437 6.602 4.994 18.318 4.994 9.41-.112 15.17-2.373 19.98-6.66 7.208-1.966 8.483-5.43 16.652-6.66 7.444 1.328 15.03 1.664 23.312 1.664 8.096-2.12 15.677-6.01 21.647-9.99 5.093-2.502 11.14-6.12 16.65-8.326 6.07 3.133 10.844 5.65 18.318 6.66 7.728-1.148 11.747-4.868 18.317-6.66 3.577-4.33 8.777-6.632 14.986-8.325 9.67-4.75 8.913 1.573 13.32 6.66 4.896 5.132 11.374 2.68 18.318 4.995 3.83 5.893 6.647 9.914 11.657 13.32 3.89 4.71 8.508 6.035 16.65 6.66 2.968 3.958.602 6.812 6.662 8.327 2.387 2.53 6.517 3.606 9.99 4.995"
                transform="matrix(.27 0 0 .32 205.39 104.9)"
                stroke="#772600"
                strokeWidth={3.5}
                fill="none"
            />
            <path
                d="M468.74 30.803v.833c0-2.327-.103-1.09 1.665 3.33.595 3.64-.81 3.22-2.498 5.828-.286 3.723-.832 6.4-.832 10.823-.537 3.612-2.57 7.04-4.163 9.99-1.604 3.133-8.555 4.87-8.326 9.16-3.99 1.14-4.084-1.445-4.162-5.83-2.386-2.726-3.212-6.466-4.996-9.99-1.108-3.476-3.47-6.032-4.995-9.99-2.46-3.787-4.546-4.876-6.66-9.16-.827-2.065-.683-4.617-2.498-5.827-2.72-3.438-4.49-3.99-9.16-4.163-3.59.845-4.97 2.416-8.324 3.33-2.57.857-7.57.58-10.823 1.666-.808 1.314 1.6 1.94 2.498 4.995-2.135 1.764-2.926 4.883-4.163 7.493-1.965 2.487-3.283 3.706-4.163 7.494 1.362 2.316.2 5.387-1.666 7.493-.574 3.864-2.434 5.874-3.33 9.16-2.686 1.825-3.652 3.537-5.828 6.66-1.914 2.678-3.636 2.497-8.326 2.497-3.667-1-4.18-2.988-7.493-4.163-.352-1.056-.608-1.312-1.665-1.664"
                transform="matrix(.27 0 0 .32 205.39 104.9)"
                stroke="#782600"
                strokeWidth={3.125}
                fill="none"
            />
            <path
                d="M307.65 125.534s-.455 4.955-3.643 8.258-9.794 7.157-9.794 7.157 8.882-4.222 9.793-3.304c.91.917-5.694 8.258-5.694 8.258s8.655-7.708 9.794-7.708 3.644 7.524 4.555 7.34c.912-.183-2.05-9.542-1.593-11.01.455-1.468 0-9.36 0-9.36l-3.416.368zm20.496-.672s-.456 5.297-3.644 8.828-9.794 7.65-9.794 7.65 8.882-4.512 9.793-3.53c.913.98-5.692 8.827-5.692 8.827s8.654-8.24 9.793-8.24 3.645 8.043 4.556 7.847c.91-.196-2.05-10.2-1.594-11.77.455-1.57 0-10.004 0-10.004l-3.416.392zm-28.693-48.045c0 .987-.967 1.788-2.16 1.788s-2.158-.8-2.158-1.788.966-1.787 2.16-1.787 2.158.8 2.158 1.787z"
                fillRule="evenodd"
                fill="#812e00"
            />
        </svg>
    );
}

export default SvgEc;
